import {Col, css, DSSpinner, Text} from "@cdx/ds";
import {VisionBoardNode} from "../../../cdx-models/utils/extended-fields";
import {NodeBushEntry} from "../useVisionBoardData";
import {dsColors} from "@cdx/ds/css/tokens";
import {VisionBoardBag} from "../canvas-utils";
import {useCanvasNode} from "./useCanvasNode";

type ImageWidgetProps = {
  node: NodeBushEntry;
  nodeData: VisionBoardNode & {type: "image"};
  bag: VisionBoardBag;
};
const ImageWidget = (props: ImageWidgetProps) => {
  const {nodeData, node, bag} = props;
  const {elements, nodeRef, containerProps} = useCanvasNode({
    node,
    nodeData,
    bag,
    forceAspect: nodeData.value.width / nodeData.value.height,
    minDims: [20, 20],
  });
  const {url, height, width} = nodeData.value;
  return (
    <Col {...containerProps} ref={nodeRef} rounded={4}>
      {!url ? (
        <Col flex="auto" align="center" justify="center">
          <DSSpinner size={24} />
        </Col>
      ) : (
        <img
          src={url}
          width={width}
          height={height}
          alt=""
          className={css({
            position: "absolute",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            pointerEvents: "none",
            objectFit: "cover",
            rounded: 4,
          })}
        />
      )}
      {elements}
    </Col>
  );
};

export default ImageWidget;

export const CanvasDropOverlay = () => (
  <Col
    absolute
    inset="0"
    zIndex={1}
    align="center"
    justify="center"
    colorTheme="active600"
    style={{backgroundColor: `${dsColors.active600}cc`}}
  >
    <Text type="label16" color="primary">
      Drop to add Image Node
    </Text>
  </Col>
);
